import { createSlice } from '@reduxjs/toolkit';
import { AGENT_STATE, MODES } from '../constants';
import LocalStorageService from '../services/localstorage.service';

function getLoginDetails() {
    let data = LocalStorageService.getObject('loginDetails');
    return data || {}
}

function getUSID() {
    let data = LocalStorageService.getItem('usId');
    LocalStorageService.removeItem('usId');
    return data || 'user'
}
const initialState = {
    loading: false,
    isLoggedIn: false,
    isOTPVerified: false,
    alreadyLoggedIn: false,
    loginDetails: getLoginDetails(),
    agentLogoffByAdmin: false,
    agent: {
        mode: MODES.INBOUND,
        state: AGENT_STATE.NOT_READY,
    },
    headerLogo: null,
    params: [],
    isSIPconnected: false,
    isSIPconnecting: true,
    isWebsocketConnected: false,
    dispositionValues: {
        rescheduleDateTime: null,
        rescheduleComment: null,
        reason: null,
        pauseReasonState: false,
        callBackTimezoneSelected: null,
        forceRedialAfterDispose: false
    },
    isDispositionOpen: false,
    dispositionForReqBody: null,
    isDispSavedAlready: false,
    multiDisposition: {
        disp1: null,
        disp1SelectedValue: null,
        disp2: null,
        disp2SelectedValue: null,
        disp3: null,
        disp3SelectedValue: null,
        disp4: null,
        disp4SelectedValue: null,
        disp5: null,
        disp5SelectedValue: null,
    },
    notificationData: [],
    usId: getUSID(),
    closeTab: false,
    sTemplates: null,
    loginViaAppData: {
        customer: null,
        agentid: null,
        phoneNumber: null,
        pin: null
    },
    isPreviewCampaignNumberScreenOpened: false,
    previewCampaignNumberDetails: {
        previewCampaings: [],
        selectedCampaingNumberDetails: [],
        campaignSelectedState: false,
        selectedCampaignData: null,
    },
    previewNumberCustomerInfo: null,
    blendedModeActiveDialer: null,
    chatOnCall: false,
    showCallStatus: false,
    showMinimizedCall: false,
    showingToolbarInCrm: false,
    isAudioSettingDiaEnabled: false,
    isChatAudioDisabled:false,
    ringAudioSkinId: null,
    beepAudoSkinId: null,
    callAudoSkinId: null,
    isTbMinimized: false,
    isAppMinimized: false,
    activeToggle: "",
    sipLoginFaild: false,
    healthCheckTime: 0,
    isChatWaiting: false,
    isToolbarTabActive: false,
    adminToken: null,
    refreshToken: null,
    isSkillTransfer: false,
    mfaCheck: false,
    isAutoCallBackMandatory: false,
    isTimerStarted: false,
    sipDisconnectPause: false,
    mfaLoading: false,
    warmTranferEnableCallEndbutton: false,
    warmTranferDisableHoldButton: false,
    isExceptionEnabled: false,
    callOnChatORChatOnCall: false,
    showMinimizedCallControls: false,
    isHeadphoneConnectedStatus: false,
    notReadyTimeOut: false,
    isExceptionState: false,
    isScreenRecordingCanceled: false,
    agentRelaseEvnTime: null,
    whatsAppTemplates: null,
    WhatsAppSavedReplys: null,
    isLogOutDialogOpened: false,
    manualData: {
        campaignsList: [],
        phoneNumbersList: [],
        skillsCache: {},
    },
    userId: null,
    isScreenRecordingEnabled: false,
    isScreenRecordingEnabledByApp: false,
    browserSessionId: null,
    parkingChatsCount: { whatsapp: 0, sms: 0 },
    isBarginRecording: false,
    sendSmsAutoSend: false
}

export const toolbarSlice = createSlice({
    name: 'toolbar',
    initialState,
    reducers: {
        login: (state, action) => {
            state.isLoggedIn = action.payload
            state.alreadyLoggedIn = !action.payload;
        },
        loading: (state, action) => {
            state.loading = action.payload;
        },
        logout: (state, action) => {
            state.isLoggedIn = false;
        },
        setMode: (state, action) => {
            state.agent.mode = action.payload;
        },
        setAgentState: (state, action) => {
            state.agent.state = action.payload;
        },
        setMfaCheck: (state, action) => {
            state.mfaCheck = action.payload;
        },
        setAleadyLoggedIn: (state, action) => {
            state.alreadyLoggedIn = action.payload;
        },
        setLoginDetails: (state, action) => {
            state.loginDetails = action.payload;
            state.params = action.payload.params;

        },
        setAgentLogoffByAdmin: (state, action) => {
            state.agentLogoffByAdmin = action.payload;
        },
        setIsSip: (state, action) => {
            state.isSip = action.payload;
        },
        setSIPConnectingStatus(state, action) {
            state.isSIPconnecting = action.payload
        },
        setSIPConnectionStatus(state, action) {
            state.isSIPconnected = action.payload
        },
        setWebsocketConnectionStatus(state, action) {
            state.isWebsocketConnected = action.payload
        },
        setDispositionValues: (state, action) => {
            if (typeof action.payload === 'object') {
                state.dispositionValues = { ...state.dispositionValues, ...action.payload };
            }
            else {
                state.dispositionValues = initialState.dispositionValues;
            }
        },
        setNotificationData: (state, action) => {
            if (action.payload?.operation === "push") {
                state.notificationData.push(action.payload)
            }
            else {
                state.notificationData = action.payload
            }
        },
        setUsId: (state, action) => {
            state.usId = action.payload;
        },
        handleMultiDisposition: (state, action) => {
            state.multiDisposition = action.payload
        },
        clearMultiDisposition: (state, action) => {
            state.multiDisposition = {
                disp1: null,
                disp1SelectedValue: null,
                disp2: null,
                disp2SelectedValue: null,
                disp3: null,
                disp3SelectedValue: null,
                disp4: null,
                disp4SelectedValue: null,
                disp5: null,
                disp5SelectedValue: null,
            }
        },
        setDispositionReqbody: (state, action) => {
            state.dispositionForReqBody = action.payload
        },
        handleDispositionEnable: (state, action) => {
            state.isDispositionOpen = action.payload
        },
        setHomePageLogo: (state, action) => {
            state.headerLogo = action.payload
        },
        setOTPVerify: (state, action) => {
            state.isOTPVerified = action.payload
        },
        closeTab: (state, action) => {
            state.closeTab = action.payload
        },
        setTemplate: (state, action) => {
            state.sTemplates = action.payload
        },
        setLoginViaAppData: (state, action) => {
            state.loginViaAppData = action.payload
        },
        setHealthCheckTime: (state, action) => {
            state.healthCheckTime = action.payload
        },
        setIsPreviewCampaignNumberScreenOpened: (state, action) => {
            state.isPreviewCampaignNumberScreenOpened = action.payload
        },
        setPreviewCampaignNumberDetails: (state, action) => {
            state.previewCampaignNumberDetails = action.payload
        },
        setPreviewNumberCustomerInfo: (state, action) => {
            state.previewNumberCustomerInfo = action.payload
        },
        setBlendedModeActiveDialer: (state, action) => {
            state.blendedModeActiveDialer = action.payload
        },
        setChatOnCall: (state, action) => {
            state.chatOnCall = action.payload
        },
        setCallStatus: (state, action) => {
            state.showCallStatus = action.payload
        },
        minimizeCall: (state, action) => {
            state.showMinimizedCall = action.payload
        },
        setShowingToolbarInCrm: (state, action) => {
            state.showingToolbarInCrm = action.payload
        },
        setAudioSettingDialog: (state, action) => {
            state.isAudioSettingDiaEnabled = action.payload
        },
        setAudioSettingSkinIds: (state, action) => {
            if (action.payload.type === "ring_audio") {
                state.ringAudioSkinId = action.payload.id;
            }
            if (action.payload.type === "beep_audio") {
                state.beepAudoSkinId = action.payload.id;
            }
            if (action.payload.type === "call_audio") {
                state.callAudoSkinId = action.payload.id;
            }
        },
        minimizeTB: (state, action) => {
            state.isTbMinimized = action.payload
        },
        minimizeApp: (state, action) => {
            state.isAppMinimized = action.payload
        },
        setActiveToggle: (state, action) => {
            state.activeToggle = action.payload
        },
        handleSipLoginFail: (state, action) => {
            state.sipLoginFaild = action.payload
        },
        setChatWaiting: (state, action) => {
            state.isChatWaiting = action.payload
        },
        setToolbarTabActive: (state, action) => {
            state.isToolbarTabActive = action.payload
        },
        setAdminToken: (state, action) => {
            state.adminToken = action.payload
        },
        setRefreshToken: (state, action) => {
            state.refreshToken = action.payload
        },
        setSkillTransfer: (state, action) => {
            state.isSkillTransfer = action.payload
        },
        setAutoCallBackMandatory: (state, action) => {
            state.isAutoCallBackMandatory = action.payload
        },
        setLogoutTimer: (state, action) => {
            state.isTimerStarted = action.payload
        },
        setSipDisconnectPause: (state, action) => {
            state.sipDisconnectPause = action.payload
        },
        setWarmTransferEnableCallEndbutton: (state, action) => {
            state.warmTranferEnableCallEndbutton = action.payload
        },
        setWarmTransferdisableHoldButton: (state, action) => {
            state.warmTranferDisableHoldButton = action.payload
        },
        setmfaLoading: (state, action) => {
            state.mfaLoading = action.payload
        },
        setExceptionState: (state, action) => {
            state.isExceptionEnabled = action.payload
        },
        setCallOnChatORChatOnCallAvailable: (state, action) => {
            state.callOnChatORChatOnCall = action.payload
        },
        setShowMinimizedCallControls: (state, action) => {
            state.showMinimizedCallControls = action.payload
        },
        setHeadphoneConnectionStatus: (state, action) => {
            state.isHeadphoneConnectedStatus = action.payload
        },
        setNotReadyTimeOut: (state, action) => {
            state.notReadyTimeOut = action.payload
        },
        setLogoutDialogOpen: (state, action) => {
            state.isLogOutDialogOpened = action.payload
        },
        setIsExceptionState: (state, action) => { // used for Exception Calls Allowed per Agent exception
            state.isExceptionState = action.payload
        },
        setScreenRecordCancelled: (state, action) => { // used for Exception Calls Allowed per Agent exception
            state.isScreenRecordingCanceled = action.payload
        },
        setScreenRecording: (state, action) => { // used for Exception Calls Allowed per Agent exception
            state.isScreenRecordingEnabled = action.payload
        },
        setScreenRecordingByApp: (state, action) => { // used for Exception Calls Allowed per Agent exception
            state.isScreenRecordingEnabledByApp = action.payload
        },
        setAgentRelaseEvnTime: (state, action) => {
            state.agentRelaseEvnTime = action.payload
        },
        setWhatsAppTemplates: (state, action) => {
            state.whatsAppTemplates = action.payload
        },
        setWhatsAppSavedReplys: (state, action) => {
            state.WhatsAppSavedReplys = action.payload
        },
        setManualData: (state, action) => {
            state.manualData = {
                ...state.manualData,         // keep existing properties
                ...action.payload            // override only the ones provided
            };
        },
        setAgentUserId: (state, action) => {
            state.userId = action.payload;
        },
        setBrowserSessionId: (state, action) => {
            state.sessionId = action.payload;
        },
        clearBrowserSessionId: (state) => {
            state.sessionId = null;
        },
        setParkingChatsCount: (state, action) => {
            state.parkingChatsCount = action.payload;
        },
        setBarginRecording: (state, action) => {
            state.isBarginRecording = action.payload;
        },
        setChatAudioDisableOnBusy: (state, action) => {
            state.isChatAudioDisabled = action.payload;
        },
        setSendSmsAutoSend: (state, action) => {
            state.sendSmsAutoSend = action.payload;
        }
    }
})
export const { setChatAudioDisableOnBusy, setBarginRecording, setParkingChatsCount, setLogoutDialogOpen, setScreenRecording, setScreenRecordingByApp, setRefreshToken, setManualData, setWhatsAppSavedReplys, setWhatsAppTemplates, setAgentRelaseEvnTime, setScreenRecordCancelled, setIsExceptionState, setPreviewNumberCustomerInfo, setNotReadyTimeOut, setHealthCheckTime, setHeadphoneConnectionStatus,
    setShowMinimizedCallControls, setCallOnChatORChatOnCallAvailable, setExceptionState, setmfaLoading, setMfaCheck, setWarmTransferEnableCallEndbutton, setWarmTransferdisableHoldButton, setSipDisconnectPause, setLogoutTimer, setAutoCallBackMandatory,
    setSkillTransfer, setAdminToken, setToolbarTabActive, setChatWaiting, handleSipLoginFail, setActiveToggle, setAudioSettingSkinIds, setAudioSettingDialog, minimizeCall, setCallStatus, setChatOnCall, setTemplate, closeTab, setOTPVerify, setHomePageLogo,
    handleDispositionEnable, setDispositionReqbody, handleMultiDisposition, login, loading, setMode, setWebsocketConnectionStatus, setNotificationData, setAleadyLoggedIn, setLoginDetails,
    logout, setAgentState, setAgentLogoffByAdmin, setIsSip, setSIPConnectionStatus, setSIPConnectingStatus, setDispositionValues,
    setUsId, setLoginViaAppData, setIsPreviewCampaignNumberScreenOpened, setPreviewCampaignNumberDetails, clearMultiDisposition, setBlendedModeActiveDialer, setShowingToolbarInCrm, minimizeTB, minimizeApp, setAgentUserId
    , setBrowserSessionId, clearBrowserSessionId, setSendSmsAutoSend
} = toolbarSlice.actions;
export default toolbarSlice.reducer;